import "react-multi-date-picker/styles/layouts/prime.css";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { insertTransaction } from "services/FinancialDepartment";
import Swal from "sweetalert2";
import { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { updateTransaction } from "services/FinancialDepartment";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { title } from "process";

export default function Modals({ editInformation, userList, updater }) {
  const [toUserFakeValue1, setToUserFakeValue1] = useState({ title: "", label: "کاربری را انتخاب کنید" });
  const [toUserFakeValue2, setToUserFakeValue2] = useState({ title: "", label: "کاربری را انتخاب کنید" });
  const addModal = useRef(null);
  const editModal = useRef(null);
  const addModalFromWallet = useRef(null);
  const addModalToWallet = useRef(null);

  const [addModalValues, setAddModalValues] = useState({ price: "", time: "", type: 1, fromWalletId: "", toWalletId: "" });
  const [editModalValues, setEditModalValues] = useState({ price: "", time: "", type: 1, fromWalletId: "", toWalletId: "", transactionId: "" });

  const addModalSubmitHandler = (e) => {
    e.preventDefault();
    let walletId = "walletId";
    if (addModalValues.type == 2) walletId = "toWalletId";

    insertTransaction({ price: addModalValues.price, type: addModalValues.type, fromWalletId: addModalValues.fromWalletId, [walletId]: addModalValues.toWalletId, mtm: parseInt(addModalValues.time.unix) }).then((value) => {
      if (value) {
        Swal.fire("تراکنش مد نظر اضافه شد.");
        updater();
        addModal.current.click();
        setAddModalValues({ price: "", time: "", type: 1, fromWalletId: null, toWalletId: null });
        setToUserFakeValue1({ title: "", label: "کاربری را انتخاب کنید" });
        setToUserFakeValue2({ title: "", label: "کاربری را انتخاب کنید" });
        setAddModalValues({ ...addModalValues, type: 1 });
      } else {
        Swal.fire("مشکلی در افزودن تراکنش پیش آمده است");
      }
    });
  };
  const editModalSubmitHandler = (e) => {
    e.preventDefault();
    updateTransaction(editModalValues.transactionId, { price: editModalValues.price, type: editModalValues.type, fromWalletId: editModalValues.fromWalletId.value, toWalletId: editModalValues.toWalletId.value, mtm: parseInt(editModalValues.time.unix) }).then((value) => {
      if (value) {
        Swal.fire("تراکنش مد نظر ویرایش شد.");
        editModal.current.click();
        updater();
      } else {
        Swal.fire("مشکلی در ویرایش تراکنش پیش آمده است");
      }
    });
  };
  useEffect(() => {
    setEditModalValues({ price: editInformation.price, time: editInformation.date, type: editInformation.type, fromWalletId: editInformation.fromWalletId, toWalletId: editInformation.toWalletId, transactionId: editInformation.transactionId });
  }, [editInformation]);

  return (
    <>
      <div className="modal fade" id="add-card-item" tabindex={-1} aria-labelledby="add-card-itemLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="add-card-itemLabel">
                افزودن تراکنش
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={addModal} />
            </div>
            <form onSubmit={addModalSubmitHandler}>
              <div className="modal-body">
                <label htmlFor="add-modal-variz-bardasht" className="text-dark fw-bolder mt-2">
                  نوع:
                </label>
                <select
                  name="type"
                  id="add-modal-variz-bardasht"
                  className=" form-select mt-1"
                  onChange={(e) => {
                    setAddModalValues({ ...addModalValues, type: e.target.value });
                  }}
                  value={addModalValues.type}
                >
                  <option value="3">برداشت</option>
                  <option value="2">تراکنش داخلی</option>
                  <option value="1">واریز</option>
                </select>
                {addModalValues.type == 2 && (
                  <>
                    <label htmlFor="add-modal-user2" className="text-dark fw-bolder mt-2">
                      از کاربر:
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isRtl={true}
                      isSearchable={true}
                      // defaultValue={}
                      value={toUserFakeValue1}
                      options={userList.map((value) => {
                        return { value: value.walletId, label: value.fullname + " - " + value.mobile };
                      })}
                      ref={addModalFromWallet}
                      onChange={(obj) => {
                        setToUserFakeValue1(obj);
                        setAddModalValues({ ...addModalValues, fromWalletId: obj.value });
                      }}
                    />
                  </>
                )}

                <label htmlFor="add-modal-user" className="text-dark fw-bolder mt-2">
                  {addModalValues.type == 2 && " به "}
                  کاربر:
                </label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isRtl={true}
                  isSearchable={true}
                  value={toUserFakeValue2}
                  defaultValue={{ title: "", label: "کاربری را انتخاب کنید" }}
                  options={userList.map((value) => {
                    return { value: value.walletId, label: value.fullname + " - " + value.mobile };
                  })}
                  ref={addModalToWallet}
                  onChange={(obj) => {
                    setToUserFakeValue2(obj);
                    setAddModalValues({ ...addModalValues, toWalletId: obj.value });
                  }}
                />

                <label htmlFor="add-modal-price" className="text-dark fw-bolder mt-2">
                  مبلغ:
                </label>
                <input
                  name="price"
                  className="form-control mt-1"
                  id="add-modal-price"
                  type="text"
                  onChange={(e) => {
                    setAddModalValues({ ...addModalValues, price: removeCommas(e.target.value) });
                  }}
                  value={addCommas(addModalValues.price)}
                ></input>

                <label htmlFor="add-modal-todo-time" className="text-dark fw-bolder mt-2">
                  تاریخ انجام:
                </label>
                <div>
                  <DatePicker
                    format="YYYY/MM/DD HH:mm:ss"
                    plugins={[<TimePicker position="left" dir="ltr" />]}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      height: "26px",
                      padding: "20px 10px",
                    }}
                    containerStyle={{
                      width: "100%",
                    }}
                    onChange={(value) => {
                      setAddModalValues({ ...addModalValues, time: value });
                    }}
                    value={addModalValues.time}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                  انصراف
                </button>
                <button className="btn btn-primary" type="submit">
                  ثبت
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="edit-card-item" tabindex={-1} aria-labelledby="edit-card-itemLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="edit-card-itemLabel">
                ویرایش تراکنش
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={editModal} />
            </div>{" "}
            <form onSubmit={editModalSubmitHandler}>
              <div className="modal-body">
                <label htmlFor="edit-modal-variz-bardasht" className="text-dark fw-bolder mt-2">
                  نوع:
                </label>
                <select
                  name="type"
                  id="edit-modal-variz-bardasht"
                  className=" form-select mt-1"
                  onChange={(e) => {
                    setEditModalValues({ ...editModalValues, type: e.target.value });
                  }}
                  value={editModalValues.type}
                >
                  <option value="3">برداشت</option>
                  <option value="2">تراکنش داخلی</option>
                  <option value="1">واریز</option>
                </select>
                {editModalValues.type == 2 && (
                  <>
                    <label htmlFor="edit-modal-user2" className="text-dark fw-bolder mt-2">
                      از کاربر:
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isRtl={true}
                      isSearchable={true}
                      options={userList.map((value) => {
                        return { value: value.walletId, label: value.fullname + " - " + value.mobile };
                      })}
                      onChange={(value) => {
                        setEditModalValues({ ...editModalValues, fromWalletId: value });
                      }}
                      value={editModalValues.fromWalletId}
                    />
                  </>
                )}
                <label htmlFor="edit-modal-user" className="text-dark fw-bolder mt-2">
                  به کاربر:
                </label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isRtl={true}
                  isSearchable={true}
                  options={userList.map((value) => {
                    return { value: value.walletId, label: value.fullname + " - " + value.mobile };
                  })}
                  onChange={(value) => {
                    setEditModalValues({ ...editModalValues, toWalletId: value });
                  }}
                  value={editModalValues.toWalletId}
                />

                <label htmlFor="edit-modal-price" className="text-dark fw-bolder mt-2">
                  مبلغ:
                </label>
                <input
                  name="price"
                  className="form-control mt-1"
                  id="edit-modal-price"
                  type="text"
                  onChange={(e) => {
                    setEditModalValues({ ...editModalValues, price: removeCommas(e.target.value) });
                  }}
                  value={addCommas(editModalValues.price)}
                ></input>

                <label htmlFor="edit-modal-todo-time" className="text-dark fw-bolder mt-2">
                  تاریخ انجام:
                </label>
                <div>
                  <DatePicker
                    format="YYYY/MM/DD HH:mm:ss"
                    plugins={[<TimePicker position="left" dir="ltr" />]}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                    style={{
                      width: "100%",
                      boxSizing: "border-box",
                      height: "26px",
                      padding: "20px 10px",
                    }}
                    containerStyle={{
                      width: "100%",
                    }}
                    onChange={(value) => {
                      setEditModalValues({ ...editModalValues, time: value });
                    }}
                    value={editModalValues.time}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                  انصراف
                </button>
                <button className="btn btn-primary" type="submit">
                  ثبت
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
